import { ShippingType } from '../enums/ShippingType';

export class ShippingUtility {
  static getShippingMethodName(shippingType: ShippingType): string {
    switch (shippingType) {
      case ShippingType.STANDARD:
        return 'shipping-method.standard';
      case ShippingType.EXPRESS:
        return 'shipping-method.express';
      case ShippingType.PICKUP:
        return 'shipping-method.pickup';
      default:
        return 'shipping-method.standard';
    }
  }
}

